<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('closeModal')">
        <div class="row">
          <div class="col-xs-0 col-sm-0 col-md-1 col-lg-1"></div>
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-10">
            <div class="modal-container" @click.stop>
              <div class="modal-header row"
                style="display: flex; justify-content: space-between; align-items: center; width: 757px; max-width: 757px; box-sizing: border-box;">
                <h2
                  style="margin: 0; font-family: Inter, sans-serif; font-weight: 700; font-size: 14px; line-height: 100%; letter-spacing: 0%;">
                  Customer Report Location</h2>
                <button type="button" class="close" @click="$emit('closeModal')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="modal-body"
                style="width: 757px; height: 381px; padding-left: 20px; padding-right: 20px; padding-bottom: 20px;">
                <GmapMap :center="{ lat: coordinate.lat, lng: coordinate.lng }" :zoom="14" map-type-id="terrain"
                  style="width: 100%; height: 100%; transform: rotate(0deg); opacity: 1;">
                  <GmapCluster>
                    <!-- <gmap-marker v-for="(m, index) in markers"
                                              :position="m.lat ? m: {lat: 0.00000 , lng: 0.0000}"
                                              :clickable="true" :draggable="true"
                                              :key="index"
                                          ></gmap-marker> -->
                    <gmap-marker :position="coordinate" :clickable="true" :draggable="false" :key="index"></gmap-marker>
                  </GmapCluster>
                </GmapMap>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-0 col-sm-0 col-md-1 col-lg-1"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      markers: null,
    };
  },
  props: ["coordinate"],
  mounted() {
    this.markers = [
      {
        lat: this.coordinate.lat,
        lng: this.coordinate.lng,
      },
    ];
  },
  methods: {},
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 1020;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 757px;
  margin: 0px auto;
  /* padding: 20px 30px; */
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header {
  border-bottom: none;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
  padding: 0;
}

.modal-default-button {
  float: right;
}

/*
      * The following styles are auto-applied to elements with
      * transition="modal" when their visibility is toggled
      * by Vue.js.
      *
      * You can easily play with the modal transition by editing
      * these styles.
      */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

/* MODAL STARTS */
.modal-body {
  margin: 0;
}

.modal-body .moduleLine {
  margin-bottom: 0vh;
}

.modal-body .moduleLine a {
  text-decoration: none;
}

.modal-body .moduleLine .moduleBox:hover {
  background-color: #e0e0e0;
  transition: background-color 0.7s ease;
  color: #212121;
  transition: color 0.7s ease;
}

.modal-body .moduleLine .moduleBox {
  border: 1px solid #bdbdbd;
  border-radius: 20px;
  padding: 20px 0;
  color: black;
  margin-bottom: 3vh;
}

.modal-body .moduleLine .moduleBox i {
  font-size: 5vh;
}

h3.modalHeadline {
  margin: 0 0 20px 0;
  font-weight: bold;
  text-align: center;
}

/* MODAL ENDS */

.modal-body {
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: auto;
  padding: 0;
  margin: 0 auto;
}
</style>